import React from 'react';
import { Await, useLoaderData } from 'react-router-dom';
import { ErrorRenderer } from '../../1_atoms/ErrorRenderer/ErrorRenderer';
import { LoaderWithLogo } from '../../1_atoms/LoaderWithLogo/LoaderWithLogo';
export const withDeferredLoaderData = (Component, key) => (props) => {
    const data = useLoaderData();
    return (React.createElement(React.Suspense, { fallback: React.createElement(LoaderWithLogo, null) },
        React.createElement(Await, { resolve: key ? data[key] : data, errorElement: React.createElement(ErrorRenderer, null) }, (data) => React.createElement(Component, Object.assign({}, props, { deferred: data })))));
};
